module.exports = __webpack_public_path__ + "img/4.51675fc9.jpg";